<div class="flex flex-row gap-2">
  <app-assistant-profile-picture [image]="model.getImageUrl()" [size]="avatarSize"></app-assistant-profile-picture>
  <app-html-viewer *ngIf="model.getIsFinished() || model.getIsStreaming" [html]="model.getHtml()"></app-html-viewer>
  <div *ngIf="!model.getIsFinished() && !model.getIsStreaming()">
    <i class="fal fa-spinner-third fa-spin" [class.fa-2x]="avatarSize === 'medium'" [class.fa-3x]="avatarSize === 'large'"></i>
  </div>
</div>
<hr/>
